import Dropdown from "./Dropdown";
import * as PropTypes from "prop-types";
import * as React from "react";
import { Overlay } from "react-overlays";
function nop() {
    // nop
}
class PortalMenu extends React.Component {
    static contextTypes = {
        menuLayer: PropTypes.object,
    };
    constructor(props) {
        super(props);
        this.state = {
            x: 0,
            y: 0,
        };
    }
    render() {
        const { onClose, open, placement, target, useMousePosition } = this.props;
        return (React.createElement(Overlay, { show: open, container: this.context.menuLayer, placement: placement ?? "bottom", onHide: nop, target: target, flip: true, rootClose: true, popperConfig: {
                modifiers: {
                    preventOverflow: {
                        boundariesElement: "window",
                    },
                },
            } }, (args) => {
            try {
                if (useMousePosition === true) {
                    args.props.style.top = this.state.y;
                    args.props.style.left = this.state.x;
                    delete args.props.style.transform;
                }
                else if (!!useMousePosition) {
                    args.props.style.top = useMousePosition.y;
                    args.props.style.left = useMousePosition.x;
                    delete args.props.style.transform;
                }
                else if (args.props.style !== undefined &&
                    args.props.style.transform !== undefined) {
                    // translate3d causes blurry text on "low-res" screens.
                    // Newer popper versions seem to account for that but react-popper still
                    // relies on an old version at the time of writing
                    const translateMatch = args.props.style.transform.match(/translate3d\((\w+), (\w+), 0\)/);
                    if (translateMatch !== undefined) {
                        args.props.style.top = translateMatch[2];
                        args.props.style.left = translateMatch[1];
                        delete args.props.style.transform;
                    }
                }
            }
            catch (err) {
                // nop, wtf is going on here?
            }
            return (React.createElement("div", { ...args.props, className: "icon-menu-positioner" },
                React.createElement("div", { className: "menu-content" },
                    React.createElement(Dropdown.Menu, { style: { display: "block", position: "initial" }, onClose: onClose, open: open, onClick: this.onClick, onSelect: this.props.onSelect }, this.props.children))));
        }));
    }
    onClick = (evt) => {
        if (this.props.useMousePosition === true) {
            this.setState({ x: evt.clientX, y: evt.clientY });
        }
        this.props.onClick(evt);
    };
}
export default PortalMenu;
